// src/services/monthlyReportService.js
import {
  loadSalesImportRows,
  movementTypeFromImportRow,
} from "./salesImportTransactionDataService";

function ymFromTranDate(tranDate) {
  const d = new Date(tranDate);
  if (Number.isNaN(d.getTime())) return null;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

// 🔸 monthly abstract (group by month) — from sales_import lineChunks
export async function getMonthlyProductAbstract(itemCode, fromDate, toDate) {
  const rows = await loadSalesImportRows({ fromDate, toDate, maxWeeks: 52 });
  const code = String(itemCode || "").trim();

  const map = {};
  for (const row of rows) {
    const part = String(row.partNo || "").trim();
    if (part !== code) continue;
    const ym = ymFromTranDate(row.tranDate);
    if (!ym) continue;
    const mov = movementTypeFromImportRow(row);
    if (!map[ym]) {
      map[ym] = {
        monthKey: ym,
        month: new Date(row.tranDate).toLocaleString("default", { month: "short", year: "2-digit" }),
        opening: 0,
        inward: 0,
        outward: 0,
        closing: 0,
      };
    }
    const qty = Number(row.qty) || 0;
    if (mov === "inward") map[ym].inward += qty;
    if (mov === "outward") map[ym].outward += qty;
  }

  let prevClosing = 0;
  return Object.values(map)
    .sort((a, b) => a.monthKey.localeCompare(b.monthKey))
    .map((r) => {
      r.opening = prevClosing;
      r.closing = prevClosing + r.inward - r.outward;
      prevClosing = r.closing;
      return r;
    });
}

// 🔸 ledger for one month
export async function getMonthlyLedger(itemCode, monthKey) {
  const rows = await loadSalesImportRows({ maxWeeks: 52 });
  const code = String(itemCode || "").trim();
  const out = [];
  let balance = 0;

  for (const row of rows) {
    const part = String(row.partNo || "").trim();
    if (part !== code) continue;
    const ym = ymFromTranDate(row.tranDate);
    if (ym !== monthKey) continue;
    const mov = movementTypeFromImportRow(row);
    const qty = Number(row.qty) || 0;
    const rowEntry = {
      id: `${row.voucherNo}_${part}_${row.tranDate}`,
      date: new Date(row.tranDate),
      voucherNo: row.voucherNo,
      type: mov || "outward",
      party: row.customerName,
      qtyIn: mov === "inward" ? qty : 0,
      qtyOut: mov === "outward" ? qty : 0,
      balance: 0,
    };
    balance += rowEntry.qtyIn - rowEntry.qtyOut;
    rowEntry.balance = balance;
    out.push(rowEntry);
  }

  return out.sort((a, b) => a.date - b.date);
}
